var render = function render(){var _vm=this,_c=_vm._self._c;return _c('client-only',[_c('portal',{ref:"portal",attrs:{"to":"limb"}},[_c('div',_vm._g({staticClass:"cases-dropdown",class:_vm.classList,attrs:{"id":_vm.ddId}},_vm.listenMouseover ? {
                mouseover: _vm.handlerover,
                mouseleave: _vm.handlerleave
            } : {}
            ),[_c('div',{directives:[{name:"bsl",rawName:"v-bsl",value:(_vm.visible && _vm.$mq == 'xs'),expression:"visible && $mq == 'xs'"}],ref:"content",staticClass:"cases-dropdown-content",class:_vm.ddContentClasses,style:({width: _vm.width || _vm.bindedWidth}),attrs:{"id":_vm.layoutId}},[(_vm.render)?_vm._t("default"):_vm._e()],2)])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }